import React, { useState, useEffect } from "react";
import { taxServiceClient, attachmentClient } from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import { Typography, IconButton } from "@material-ui/core";
import "filepond/dist/filepond.min.css";
import UploadError from "../../components/messages/UploadError";

registerPlugin(FilePondPluginFileValidateType);
const acceptedFileTypes = ["image/*"];

function ChangeAvatarDialog(props) {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);
  const apiLocation = useSelector((state) => state.setting.apiLocation);
  const [attachmentId, setAttachmentId] = useState(-1);
  const [uploadError, setUploadError] = useState(null);
  useEffect(
    () => {
      if (!attachmentId) return;
      props.fileUploadStateUpdated(attachmentId);
    },
    [attachmentId]
  );

  const getTransKeyFromHttpStatus = (status, message) =>{
    let translationKey = "unexpected_upload_error";
    switch(status){
      case 409:
        translationKey="virus_detected_in_file"
        break;
      case 413:
        translationKey="file_too_big_to_process"
        break;
      case 418: 
        // I'm a teapot. 
        // Temporary method to handle internal 500 errors. See UV6-1207 
        // Error type is propagated as a translation key
        // First characters are the Http status it prepresents
        // e.g. 500_AV_NOT_DEFINED
        if(!!message && message.length>0){
          translationKey = message;
        }
    }
    return translationKey;
  }

  return (
    <div>
      <div>
        <Typography gutterBottom>
          {t("upload_new_profile_picture_subheader")}
        </Typography>
      </div>
      <FilePond
        files={files}
        allowMultiple={false}
        allowRevert={true}
        acceptedFileTypes={acceptedFileTypes}
        allowSyncAcceptAttribute={false}
        labelFileTypeNotAllowed={t("invalid_file_type")}
        fileValidateTypeLabelExpectedTypes={t("only_image_types_are_supported")}
        server={{
          process: (
            fieldName,
            file,
            metadata,
            load,
            error,
            progress,
            abort,
            transfer,
            options
          ) => {
            let timeout = null;
            const formData = new FormData();
            formData.append("file", file, file.name);
            const request = new XMLHttpRequest();
            request.withCredentials = true
            request.open(
              "POST",
              `https://${apiLocation}/attachmentservice/attachment/upload/`
            );
            request.upload.onprogress = (e) => {
              progress(e.lengthComputable, e.loaded, e.total);
            };
            request.onload = () => {
              let payload = JSON.parse(request.responseText);
              if (request.status >= 200 && request.status < 300) {
                load(payload.id);
              } else{
                let key = getTransKeyFromHttpStatus(request.status, payload.message);
                error(t(key));
                setUploadError(key);
              }
            };
            request.send(formData);
            return {
              abort: () => {
                request.abort();
                abort();
              },
            };
          },
        }}
        onprocessfile={(_err, file) => {
          if (!_err || _err.type != "error") {
            let uploadedFile = JSON.parse(file.serverId);
            setAttachmentId(uploadedFile.id ? uploadedFile.id : uploadedFile);
          }
        }}
        onupdatefiles={(fileItems) => {
          setFiles(fileItems.map((fileItem) => fileItem.file));
        }}
      />
      <UploadError
        uploadError={uploadError}
        setUploadError={() => setUploadError(false)}
      />
    </div>
  );
}

export default ChangeAvatarDialog;
